import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { Button } from "@/components/ui/button";
import { ClipboardCheck } from "lucide-react";
import { toast } from "sonner";

export const REVIEW_STATUS = { assigned: "Not started", in_progress: "In progress", reopened: "Reopened for corrections", submitted: "Submitted" };
export const STATUS_CLS = { assigned: "bg-slate-100 text-slate-600", in_progress: "bg-amber-50 text-amber-700", reopened: "bg-sky-50 text-sky-700", submitted: "bg-emerald-50 text-emerald-700" };

export default function MyReviews() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/form-assignments/mine").then((r) => setItems(r.data.items)).catch((e) => { toast.error(apiError(e)); setItems([]); }); }, []);
  return (
    <div>
      <PageHeader title="My Reviews" description="Annual reviews and surveys assigned to you by your District Office." />
      {!items ? <p className="text-sm text-slate-400">Loading…</p> : !items.length ? (
        <p className="text-sm text-slate-500 border border-dashed rounded-xl p-8 text-center" data-testid="my-reviews-empty">You have no reviews assigned right now.</p>
      ) : (
        <div className="space-y-2" data-testid="my-reviews-list">
          {items.map((a) => (
            <div key={a.id} className="flex flex-wrap sm:flex-nowrap items-center gap-x-4 gap-y-2 rounded-xl border border-slate-200 bg-white p-4 shadow-sm" data-testid={`my-review-${a.id}`}>
              <ClipboardCheck className="w-5 h-5 text-brand shrink-0" />
              <div className="flex-1 min-w-[12rem]">
                <p className="font-medium text-slate-900 sm:truncate">{a.form_name}</p>
                <p className="text-xs text-slate-500">Review year {a.review_year} · Planning year {a.planning_year}</p>
              </div>
              <span className={`text-xs font-semibold rounded-full px-2.5 py-1 ${STATUS_CLS[a.status]}`}>{REVIEW_STATUS[a.status] || a.status}</span>
              <Button size="sm" className="bg-brand hover:bg-brand-strong" onClick={() => navigate(`/my-reviews/${a.id}`)} data-testid={`my-review-open-${a.id}`}>
                {a.status === "submitted" ? "View" : a.status === "assigned" ? "Start" : "Continue"}</Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
